var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("What is your email address?")]),_c('FormTemplate',{attrs:{"formFields":_vm.formLayout,"formData":_vm.formFields},on:{"fieldSet":_vm.setParentData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }